// extracted by mini-css-extract-plugin
export default {"wrapper":"AddNewCar_wrapper__ST9QX","sidebar":"AddNewCar_sidebar__8PZRP","active":"AddNewCar_active__P6Qbv","content":"AddNewCar_content__9klDa","actions":"AddNewCar_actions__VvvNM"};